import React, { useEffect, useRef, useState } from 'react';
import * as styles from './AWProductShowcase.module.css';

const PRODUCT_LISTS: Record<string, string[]> = {
    '01': ['Manzanas', 'Peras', 'Uvas & Cerezas', 'Fresas', 'Frambuesas & Arándanos', 'Naranjas & Pomelos', 'Mandarinas', 'Clementinas & Limas', 'Piña & Mango', 'Aguacate & Papaya', 'Melón & Sandía', 'Kiwi & Melocotón', 'Ciruelas & Nectarinas', 'Granada', 'Higos & Dátiles', 'Chirimoya & Coco', 'Plátano & Lichi', 'Pitahaya & Carambola', 'Frutos del Bosque'],
    '02': ['Mora & Lulo', 'Maracuyá', 'Granadilla', 'Guanábana & Chirimoya', 'Mango & Piña', 'Fresa & Mora', 'Tomate de Árbol', 'Guayaba & Papaya', 'Limón & Mandarina', 'Tamarindo & Borojó', 'Frutos Rojos', 'Naranjilla', 'Taxo & Uvilla'],
    '03': ['Tomates', 'Cebollas', 'Zanahorias & Pimientos', 'Lechugas & Espinacas', 'Brócoli & Coliflor', 'Pepino & Calabacín', 'Acelga & Apio', 'Papas & Yuca', 'Ajos y Jengibre', 'Perejil, Cilantro & Hierbas'],
    '04': ['Arroz', 'Maíz', 'Fréjol & Lentejas', 'Garbanzos & Arvejas', 'Quinua & Avena', 'Harinas & Semillas'],
    '05': ['Cortes Premium Res', 'Lomo Fino', 'Solomillo', 'Punta de Anca', 'Costillas (Ribs)', 'Carne Molida & Hamburguesas', 'Chuleta & Lomo de Cerdo', 'Tocino & Panceta', 'Cordero & Cabrito', 'Vísceras Seleccionadas'],
    '06': ['Pollo Entero', 'Pollo Despresado', 'Pechuga & Filetes', 'Muslos & Contramuslos', 'Alas (Enteras & BBQ)', 'Menudencias & Hígados', 'Nuggets & Apanados', 'Pavo & Pato'],
    '07': ['Salmón & Trucha', 'Tilapia & Pargo', 'Atún & Albacora', 'Camarones', 'Langostinos', 'Pulpo, Calamar & Jibia', 'Mejillones & Almejas', 'Corvina & Dorado', 'Cangrejo & Langosta'],
    '08': ['Jamón Serrano & Ibérico', 'Jamón Cocido & York', 'Jamón de Pavo', 'Jamón de Pollo', 'Salame & Pepperoni', 'Chorizos & Longanizas', 'Mortadela & Salchichón', 'Prosciutto & Bondiola', 'Tocinetas Ahumadas'],
    '09': ['Mozzarella', 'Cheddar', 'Parmesano & Reggiano', 'Queso Crema & Ricotta', 'Queso Fresco', 'Gouda, Edam & Holandés', 'Queso Azul & Roquefort', 'Brie & Camembert', 'Gruyère'],
    '10': ['Leche Entera & Descremada', 'Yogur Natural & Frutado', 'Mantequilla & Margarina', 'Crema de Leche', 'Bebidas Lácteas', 'Avenas', 'Helados & Postres', 'Dulce de Leche & Manjar'],
    '11': ['Huevos', 'Salsas & Aderezos', 'Aceites & Vinagres', 'Especias & Condimentos', 'Enlatados & Conservas', 'Pastas & Harinas', 'Snacks & Galletas', 'Bebidas & Jugos']
};

const ITEMS = [
    { id: '01', name: 'FRUTAS', img: '001_fr_bg_gb.png' },
    { id: '02', name: 'PULPAS', img: '002_pu_bg_gb.png' },
    { id: '03', name: 'VEGETALES', img: '003_vg_bg_gb.png' },
    { id: '04', name: 'GRANOS', img: '004_gr_bg_gb.png' },
    { id: '05', name: 'CARNES', img: '005_cr_bg_gb.png' },
    { id: '06', name: 'POLLO', img: '006_po_bg_gb.png' },
    { id: '07', name: 'PESCADOS', img: '007_pe_bg_gb.png' },
    { id: '08', name: 'JAMONES', img: '008_ja_bg_gb.png' },
    { id: '09', name: 'QUESOS', img: '009_qu_bg_gb.png' },
    { id: '10', name: 'LÁCTEOS', img: '010_la_bg_gb.png' },
    { id: '11', name: 'OTROS', img: '011_ot_bg_gb.png' },
];

const ProductSection = ({ item, isRight }: { item: { id: string, name: string, img: string }, isRight: boolean }) => {
    const products = PRODUCT_LISTS[item.id] || [];
    const [isVisible, setIsVisible] = useState(false);
    const cardRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setIsVisible(entry.isIntersecting);
            },
            {
                threshold: 0.3,
                rootMargin: "0px 0px -25% 0px"
            }
        );

        if (cardRef.current) observer.observe(cardRef.current);
        return () => observer.disconnect();
    }, []);

    return (
        <div className={styles.section}>
            {/* Background Image */}
            <img
                src={`/assets/backgounds/${item.img}`}
                alt={item.name}
                className={styles.bgImage}
            />

            {/* Content Container */}
            <div className={`${styles.contentWrapper} ${isRight ? styles.alignRight : styles.alignLeft}`}>
                <div
                    ref={cardRef}
                    className={`${styles.card} ${isVisible ? styles.visible : styles.hidden}`}
                >
                    <h2 className={styles.categoryTitle}>{item.name}</h2>
                    <div className={styles.singleColumnList}>
                        {products.map((prod, i) => (
                            <div key={i} className={styles.productItem}>
                                {prod}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export const AWProductShowcase: React.FC = () => {
    return (
        <div className={styles.container}>
            {ITEMS.map((item, index) => (
                <ProductSection key={item.id} item={item} isRight={index % 2 !== 0} />
            ))}
        </div>
    );
};
